<template>
    <div>

        <!-- Cabecera -->
        <b-row>
            <b-col cols="12" class="px-4 py-2">
                <h3>
                    <strong>PLAN DE ACCIÓN EN SEGURIDAD QUÍMICA</strong>
                </h3>
                <p><strong>FECHA DE REPORTE</strong>: {{ plan_accion.data.fecha_inicio_visita }}</p>
            </b-col>
        </b-row>

        <b-row>
            <b-col v-for="(list, index) in getListApplied" cols="12" :key=index>

                <div class="table-responsive">

                    <div class="w-full bg-gray text-left m-0 p-3 border">
                        <h5 class="p-0 m-0"><strong class="text-white">{{ list.nombre }}</strong></h5>
                    </div>

                    <b-table responsive hover striped thead-class="table-active" show-empty empty-text="No hay productos para mostrar"
                        :items="getItemsByCategory(list)" :fields="fields">

                        <!-- Observaciones -->
                        <template v-slot:cell(0)="data">
                            {{ data.item.observaciones }}
                        </template>

                        <!-- Acciones de mejora -->
                        <template v-slot:cell(1)="data">

                            <el-input type="textarea" v-model="data.item.opciones_mejora" :rows="5" />

                        </template>

                        <!-- Responsable -->
                        <template v-slot:cell(2)="data">

                            <b-form-select v-model="data.item.wor_worker_id"
                                           id="responsable"
                                           name="responsable"
                                           text-field="fullName"
                                           value-field="id"
                                           :options="workersList"
                                           v-validate="'required'"
                            />
                        </template>

                        <!-- Estado -->
                        <template v-slot:cell(3)="data">

                            <el-select v-model="data.item.state" class="content-select-states">
                                <el-option v-for="item in statesAvailables" :key="item.id" :value="item.title">
                                    <div :style="{ backgroundColor: item.backgroundColor, color: item.color }" class="item-select-states">
                                        {{ item.title }}
                                    </div>
                                </el-option>
                            </el-select>

                        </template>

                        <!-- Acciones -->
                        <template v-slot:cell(4)="data">

                            <el-tooltip :content="data.detailsShowing ? 'Ocultar detalles' : 'Ver detalles'" placement="top"
                                effect="light">
                                <b-button size="sm" @click="data.toggleDetails" class="mr-2">
                                    <i :class="`fa fa-chevron-${data.detailsShowing ? 'up' : 'down'} fa-lg`"></i>
                                </b-button>
                            </el-tooltip>

                            <el-tooltip content="Guardar cambios" placement="top" effect="light">
                                <b-button size="sm" variant="primary" @click="updateFindings('ITEM', data.item)"><i
                                        class="fa fa-floppy-o fa-lg"></i></b-button>
                            </el-tooltip>

                        </template>

                        <!-- Detalles generales -->
                        <template #row-details="data">
                            <b-card>
                                <b-row class="mb-2">
                                    <b-col sm="4" md="2" class="text-sm-right"><b>LEGISLACIÓN:</b></b-col>
                                    <b-col>
                                        {{ data.item.item.legislacion || "No registra" }}
                                    </b-col>
                                </b-row>

                                <b-row class="mb-2">
                                    <b-col sm="4" md="2" class="text-sm-right"><b>AREA:</b></b-col>
                                    <b-col>
                                        {{ data.item.ubicacion || "No registra" }}
                                    </b-col>
                                </b-row>


                                <b-row class="mb-2">
                                    <b-col sm="4" md="2" class="text-sm-right"><b>FECHA DE CIERRE:</b></b-col>
                                    <b-col>
                                        {{ fecha(datos_accion.fecha_cierre_visita) || "No registra" }}
                                    </b-col>
                                </b-row>

                                <b-row class="mb-2">
                                    <b-col sm="4" md="2" class="text-sm-right"><b>FOTOGRÁFIAS:</b></b-col>
                                    <b-col cols="1" v-for="imagen in data.item.imagenes" :key="imagen.id">
                                        <b-img
                                            style="border-radius: 6px; width: 100%; object-fit: contain; cursor: pointer;"
                                            thumbnail fluid :src="'data:image/gif;base64,' + imagen.imagen" alt="Logo"
                                            class="logo-empresa" @click="verImagen(imagen)" />
                                    </b-col>
                                    <b-col cols="4" v-if="!data.item.imagenes || data.item.imagenes.length <= 0">
                                        <span>No existe registro fotográfico</span>
                                    </b-col>
                                </b-row>

                                <div class="d-flex justify-content-end">
                                    <el-tooltip content="Ocultar detalles" placement="top" effect="light">
                                        <b-button size="sm" @click="data.toggleDetails" class="mr-2">
                                            <i class="fa fa-chevron-up fa-lg mr-2"></i>
                                            <span>Ocultar detalles</span>
                                        </b-button>
                                    </el-tooltip>
                                </div>
                            </b-card>
                        </template>

                    </b-table>

                </div>

            </b-col>
        </b-row>

        <!-- Navegación -->
        <b-row>
            <b-col class="text-center">
                <hr>
                <b-button to="/listas-chequeo" variant="secondary" class="float-left">
                    <i class="fa fa-reply fa-lg" /> Volver
                </b-button>
                <b-button variant="primary" class="mx-1" @click="updateFindings('ALL', null)">
                    <i class="fa fa-save" />
                    Guardar
                </b-button>
                <b-button variant="success" class="mx-1" @click="descargarPlanAccion()">
                    <i class="fa fa-download" />
                    Descargar Reporte
                </b-button>
            </b-col>
        </b-row>

        <!-- Modal para detalles de los registros fotográficos -->
        <b-modal v-model="modal_imagen" hide-footer hide-header centered body-class="p-0">
            <b-row>
                <b-col class="text-center">
                    <b-img style="margin:auto; width: 100%" thumbnail fluid
                        :src="'data:image/gif;base64,' + imagen_seleccionada" alt="Logo" class="logo-empresa" />
                </b-col>
            </b-row>
        </b-modal>

    </div>
</template>

<script>

// Importaciones generales
import { mapActions, mapMutations, mapState } from 'vuex';

export default {
    name: 'plan-accion',
    data() {
        return {
            arr: [0, 1],
            modal_imagen: false,
            fields: [
                {
                    key: '0',
                    label: 'CONDICIÓN REPORTADA',
                    sortable: true,
                    thStyle: {
                        'width': '30%'
                    }
                },
                {
                    key: '1',
                    label: `ACCIÓN CORRECTIVA SUGERIDA (condición sub-estándar)`,
                    sortable: true,
                    thStyle: {
                        'width': '35%'
                    }
                },
                {
                    key: '2',
                    label: 'RESPONSABLE',
                    sortable: false,
                    thStyle: {
                        'width': '15%'
                    }
                },
                {
                    key: '3',
                    label: 'ESTADO',
                    sortable: false,
                    thStyle: {
                        'width': '10%'
                    }
                },
                {
                    key: '4',
                    label: 'ACCIONES',
                    sortable: false,
                    thStyle: {
                        'width': '10%'
                    }
                },
            ],
            statesAvailables: [
                {
                    id: 1,
                    title: 'ABIERTO',
                    backgroundColor: '#B80015',
                    color: 'white'
                },
                {
                    id: 2,
                    title: 'PROGRESO',
                    backgroundColor: '#FCE903',
                    color: 'black'
                },
                {
                    id: 3,
                    title: 'CERRADO',
                    backgroundColor: '#106B21',
                    color: 'white'
                },

            ],
            isVisibleContent: true
        };
    },
    computed: {
        ...mapState('listaChequeo', [
            'selectedListaChequeo',
            'imagen_seleccionada',
            'listaTipoSeguimientos',
            'plan_accion',
            'datos_accion',
            'imagenPlanAccion'
        ]),
      ...mapState('findings', ['responsibles']),
        /**
         * Cargar las listas de chequo validas.
         *
         * @author Fernando Claros
         */
        getListApplied() {
            return this.listaTipoSeguimientos.filter(x => this.plan_accion.data.hallazgos.find(h => h.id_tipo_seguimiento == x.id)) || []
        },
        workersList() {
          if (!this.responsibles.length) return [];
          return this.responsibles.map(worker => ({
            ...worker,
            fullName: `${worker.names} ${worker.surnames} - ${worker.identification}`
          }));
      }
    },
    methods: {
        ...mapActions('listaChequeo', [
            'verPlanAccion',
            'descargarPlanAccion',
            'editarDataPlanAccion',
            'verImagenOriginal'
        ]),
        ...mapMutations('listaChequeo', [
            'resetPlanAccion'
        ]),
        /**
         * Actualiza los hallazgos.
         *
         * Puede ser todos los items: 'ALL', un item: 'ITEM'.
         *
         * @param {*} typeUpdating
         * @param {*} currentFinding
         * @author Fernando Claros
         */
        async updateFindings(typeUpdating = 'ALL', currentFinding = null) {

            let payload = {
                id_empresa: this.selectedListaChequeo.id_empresa,
                hallazgos: []
            };

            // Todos los hallazgos son organizados para ser actualizados
            if (typeUpdating == 'ALL') {
                this.getListApplied.map(list => {
                    this.getItemsByCategory(list).map(finding => {
                        payload.hallazgos.push({
                            "id_empresa": this.selectedListaChequeo.id_empresa,
                            "id_hallazgo": finding.id,
                            "wor_worker_id": finding.wor_worker_id,
                            "opciones_mejora": finding.opciones_mejora,
                            "porcentaje_implementacion": finding.porcentaje_implementacion,
                            "state": finding.state
                        });
                    })
                })
            }

            // Solo el hallazgo que se quiere actualizar
            else {
                payload.hallazgos = [{
                    "id_empresa": this.selectedListaChequeo.id_empresa,
                    "id_hallazgo": currentFinding.id,
                    "responsable": currentFinding.responsable,
                    "wor_worker_id": currentFinding.wor_worker_id,
                    "opciones_mejora": currentFinding.opciones_mejora,
                    "porcentaje_implementacion": currentFinding.porcentaje_implementacion,
                    "state": currentFinding.state
                }];
            }
            await this.editarDataPlanAccion(payload);

        },
        fecha(fecha) {
            if (fecha) {
                return fecha.replace(' ', '\n');
            }

            return 'No registra';
        },
        estiloFila(hallazgo) {
            const porcentaje = hallazgo.porcentaje_implementacion;

            if (porcentaje >= 0 && porcentaje < 60) {
                return 'text-center table-danger';
            } else if (porcentaje >= 60 && porcentaje < 80) {
                return 'text-center table-warning';
            } else if (porcentaje >= 80) {
                return 'text-center table-success';
            }

            return 'text-center';
        },
        async verImagen(imagen) {
            await this.verImagenOriginal(imagen.id).then(() => {
                this.modal_imagen = true;
            });
        },
        /**
         * Cargar los hallazgos de por listas de chequeo.
         *
         * @param {*} list
         * @author Fernando Claros
         */
        getItemsByCategory(list) {
            return this.plan_accion.data.hallazgos.filter(x => {

                if (x.id_tipo_seguimiento == list.id) {
                    x.responsable = x.responsable ? x.responsable : this.selectedListaChequeo.responsable
                    return x;
                }
            }) || []
        },
        getTbodyTrClass(item) {
            return `bg-${item.state}`;
        },
    },
    beforeDestroy() {
        this.resetPlanAccion();
    }
};
</script>

<style scoped>
.item-photo {
    padding: 10px;
    background-color: white;
}

.item-photo:hover {
    cursor: pointer;
    background-color: #ccc;
}

.bg-gray {
    background-color: #097B83 !important;
}

.bg-ABIERTO {
    background-color: #B80015 !important;
}

.bg-PROGRESO {
    background-color: #FCE903 !important;
}

.bg-CERRADO {
    background-color: #106B21 !important;
}

.item-select-states {
    padding: 0px 40px;
    margin: 3px 0;
    text-align: center;
    width: 100%;
    border-radius: 10px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.item-select-states:hover {
   opacity: 0.7;
}

</style>
